import { render, staticRenderFns } from "./SiedbarComponent.vue?vue&type=template&id=5301ebc2&scoped=true&"
import script from "./SiedbarComponent.vue?vue&type=script&lang=js&"
export * from "./SiedbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./SiedbarComponent.vue?vue&type=style&index=0&id=5301ebc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5301ebc2",
  null
  
)

export default component.exports